/**
 * Collapse dynamic URL segments into stable route patterns for analytics.
 *
 * Clarity/GA4 record one distinct URL per patient/order (502 distinct
 * /patients/<id> URLs in a single 3-day window), so per-view numbers
 * fragment into unusable slices. Tracking calls send this pattern instead.
 *
 * PII rule (see useClarity.ts): ids are REPLACED, never partially kept —
 * the output must contain no patient/order/pharmacy identifiers.
 */
export function normalizeRoutePattern(pathname: string): string {
  let p = pathname
    // Patient 360 composite id: "<24-hex mongo id>_<patient number>"
    .replace(/\/[0-9a-f]{24}_\d+(?=\/|$)/gi, '/:patientId')
    // uuid segments (order ids, billing item ids, ...)
    .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi, '/:id')
    // bare 24-hex mongo ids (pharmacy ids, ...)
    .replace(/\/[0-9a-f]{24}(?=\/|$)/gi, '/:id')
    // long numeric segments (rx numbers, conversation ids, ...)
    .replace(/\/\d{4,}(?=\/|$)/g, '/:id');
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  return p || '/';
}
